import axios from 'axios';
import Cookies from 'js-cookie';

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
    const excludedUrl = 'https://atlas.microsoft.com/map/tileset';
    if (config.url && config.url.includes(excludedUrl)) {
        delete config.headers['Authorization'];
        delete config.headers['x-functions-key'];
        return config;
      }
      
      // Attach headers for other requests
      config.headers = config.headers || {};
      const accessToken = Cookies.get("idToken") || "";
      config.headers['Authorization'] = `${accessToken}`;
      config.headers['x-functions-key'] = `${process.env.REACT_APP_CUSTOM_HEADER}`;
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};
